import { FilterCompTypes } from 'app/ComponentLibrary/Filter/utils';

export const FacilityOrderPayPackagesFilterName = {
  orderId: 'orderId',
  weeklyGrossMargin: 'weeklyGrossMargin',
  shift: 'shift',
  postingStatus: 'postingStatus',
} as const;

export const defaultFilterValues = {
  [FacilityOrderPayPackagesFilterName.orderId]: [],
  [FacilityOrderPayPackagesFilterName.weeklyGrossMargin]: [],
  [FacilityOrderPayPackagesFilterName.shift]: [],
  [FacilityOrderPayPackagesFilterName.postingStatus]: [],
};

export class FacilityOrderPayPackagesFilterSpecs {
  constructor(
    public filterSpecs: {
      orderIdOpts: { id: number; name: string; value: string }[];
      weeklyGrossMarginOpts: { id: number; name: string; value: string }[];
      shiftOpts: { id: number; name: string; value: string }[];
      postingStatusOpts: { id: number; name: string; value: string }[];
    },
    public t: any,
  ) {}

  getSpecs = () => [
    {
      filterName: this.t('order.payPackagesTab.orderPayPackages.grid.column.orderId'),
      name: FacilityOrderPayPackagesFilterName.orderId,
      type: FilterCompTypes.TYPEAHEADDROPDOWN,
      options: this.filterSpecs.orderIdOpts,
      isMultiSelect: true,
      isSelectAll: true,
      applyOnClickAway: true,
      applyOnEnter: true,
      searchOnCharacterCount: 1,
    },
    {
      filterName: this.t('order.payPackagesTab.orderPayPackages.filter.weeklyGrossMargin'),
      name: FacilityOrderPayPackagesFilterName.weeklyGrossMargin,
      type: FilterCompTypes.TYPEAHEADDROPDOWN,
      options: this.filterSpecs.weeklyGrossMarginOpts,
      isMultiSelect: true,
      isSelectAll: true,
      applyOnClickAway: true,
      applyOnEnter: true,
      searchOnCharacterCount: 1,
    },
    {
      filterName: this.t('order.payPackagesTab.orderPayPackages.grid.column.shift'),
      name: FacilityOrderPayPackagesFilterName.shift,
      type: FilterCompTypes.TYPEAHEADDROPDOWN,
      options: this.filterSpecs.shiftOpts,
      isMultiSelect: true,
      isSelectAll: true,
      applyOnClickAway: true,
      applyOnEnter: true,
      searchOnCharacterCount: 1,
    },
    {
      filterName: this.t('order.payPackagesTab.orderPayPackages.grid.column.postingStatus'),
      name: FacilityOrderPayPackagesFilterName.postingStatus,
      type: FilterCompTypes.TYPEAHEADDROPDOWN,
      options: this.filterSpecs.postingStatusOpts,
      isMultiSelect: true,
      isSelectAll: true,
      applyOnClickAway: true,
      applyOnEnter: true,
      searchOnCharacterCount: 1,
    },
  ];
}
